import { useState } from "react";

import { tw } from "~/utils";
import { icons } from "../Icons";

export interface ModalAction {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
}

type ModalActionsVariant = "default" | "inverted";

interface ModalActionsProps {
  actions: ModalAction[];
  variant?: ModalActionsVariant;
}

const triggerVariants: Record<ModalActionsVariant, string> = {
  default: "bg-lavender text-white",
  inverted: "text-indigo bg-white",
};

export const ModalActions = ({
  actions,
  variant = "default",
}: ModalActionsProps) => {
  const [showActions, setShowActions] = useState(false);

  return (
    <div className="relative">
      <button
        type="button"
        aria-label="More actions"
        className={tw(
          "flex h-9 w-9 cursor-pointer items-center justify-center rounded-lg text-2xl",
          triggerVariants[variant],
          showActions && "ring-2 ring-[#6D96FF99]",
        )}
        onClick={() => setShowActions((prev) => !prev)}
      >
        <icons.outline.EllipsisHorizontalIcon className="h-6" />
      </button>

      {showActions && (
        <div className="divide-light-lavender-gray text-indigo border-light-lavender-gray absolute right-0 z-20 mt-1.5 w-56 divide-y rounded-lg border bg-white shadow-sm">
          {actions.map((action) => (
            <button
              key={action.label}
              onClick={() => {
                setShowActions(false);
                action.onClick();
              }}
              disabled={action.disabled}
              className={tw(
                "hover:bg-lightBlue w-full px-6 py-3 text-left text-lg",
                action.disabled
                  ? "cursor-not-allowed opacity-50"
                  : "cursor-pointer",
              )}
            >
              {action.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
